<template>
	<b-container v-if="form" fluid class="d-flex flex-column w-100 h-100 px-2">
		<b-row v-for="section in form.Sections" :key="section.Name" class="p-3 m-0">
			<b-col class="m-0">
				<b-card no-body class="p-3">
					<b-form-group
						:label="section.Label"
						label-cols="12"
						label-cols-lg="12"
						label-class="font-weight-bold text-dark pt-0 pb-2"
						label-align-sm="left"
						label-size="lg"
						class="m-0" />
					<Fields v-bind:ConsultMode="ConsultMode" :ParentFormName="form.Name" :Fields.sync="section.Fields" :Variant="Variant" />
				</b-card>
			</b-col>
		</b-row>
	</b-container>
</template>

<script lang="ts">
import { Component } from "vue-property-decorator";
import Fields from "@/components/commons/Fields.vue";
import { BaseObjectForm } from "./BaseObjectForm";

/** Formulaire fiche Identité de la fiche objet */
@Component({
	components: {
		Fields
	}
})
export default class Identity extends BaseObjectForm {

}
</script>

<style scoped>

</style>